import React from 'react';
import { 
  ShieldCheck, 
  Image as ImageIcon, 
  Trash2, 
  Upload, 
  AlertCircle, 
  CheckCircle2,
  ChevronRight,
  Info
} from 'lucide-react';

const Rules = ({ theme }) => {
  const handleBack = () => {
    window.location.href = '/addPagenation';
  };

  const sections = [
    {
      title: "Elan Yerləşdirmə Qaydaları.",
      icon: <ShieldCheck className="text-emerald-500" />,
      content: [
        "Hər bir elan dəqiq və dürüst məlumatları əks etdirməlidir.",
        "Məhsulun vəziyyəti (yeni və ya işlənmiş) mütləq qeyd edilməlidir.",
        "Qadağan olunmuş məhsulların (silah, narkotik, saxta sənəd və s.) satışı qadağandır.",
        "Eyni elanı qısa vaxt ərzində təkrar yerləşdirmək olmaz."
      ]
    },
    {
      title: "Şəkillərlə İş: Yükləmə və Silmə",
      icon: <ImageIcon className="text-blue-500" />,
      content: [
        "Yalnız məhsulun özünə aid real şəkillər yükləyin (internetdən götürülmüş şəkillər silinə bilər).",
        "Şəkilləri yükləmək üçün 'Şəkil Əlavə Et' düyməsini sıxın və faylları seçin.",
        "Yüklədiyiniz şəkli silmək üçün şəklin üzərindəki 'X' və ya zibil qabı (Trash) ikonuna toxunmağınız kifayətdir.",
        "Məhsulun müxtəlif bucaqlardan çəkilmiş ən az 3 şəklini yükləmək tövsiyə olunur."
      ]
    },
    {
      title: "PostAdSection: Sürətli Satış",
      icon: <Upload className="text-purple-500" />,
      content: [
        "Əsas səhifədəki 'Elan Yerləşdir' bölməsi vasitəsilə kateqoriyanı seçib saniyələr içində elanınızı hazırlaya bilərsiniz.",
        "Düzgün kateqoriya seçimi (Ev, Maşın, Telefon) alıcıların sizi tapmasını 3 qat sürətləndirir.",
        "Elan yerləşdirdikdən sonra məlumatları redaktə etmək üçün 'Profilim' bölməsinə keçid edə bilərsiniz."
      ]
    }
  ];

  return (
<div
  className="
    min-h-screen
    py-12 px-4 md:px-8
    transition-colors duration-500

    bg-gray-50
    text-gray-900

    dark:bg-[#080a12]
    dark:text-white
  "
>
  <div className="max-w-4xl mx-auto">

    {/* =========================================================
        BAŞLIQ
    ========================================================== */}
    <div className="text-center mb-16 space-y-4">

      <div
        className="
          inline-flex items-center gap-2
          px-4 py-2
          rounded-full
          bg-blue-500/10
          text-blue-600
          dark:text-blue-400
          text-xs
          font-black
          uppercase
          tracking-widest
          transition-colors
        "
      >
        <Info size={14} />
        Kömək Mərkəzi
      </div>

      <h1
        className="
          text-4xl md:text-5xl
          font-black
          italic
          tracking-tight
          text-gray-900
          dark:text-white
        "
      >
        İstifadə{" "}
        <span className="text-blue-600 dark:text-blue-400">
          Qaydaları
        </span>
      </h1>

      <p
        className="
          text-lg
          max-w-2xl
          mx-auto
          text-gray-600
          dark:text-gray-300
          leading-relaxed
          transition-colors
        "
      >
        Platformamızda təhlükəsiz və sürətli alış-veriş üçün
        aşağıdakı təlimatlarla tanış olmağınız xahiş olunur.
      </p>

    </div>


    {/* =========================================================
        MƏLUMAT KARTLARI
    ========================================================== */}
    <div className="space-y-8">

      {sections.map((section, idx) => (

        <div
          key={idx}
          className="
            p-6 md:p-8
            rounded-[2.5rem]

            bg-white
            dark:bg-white/[0.04]

            border
            border-gray-200
            dark:border-white/[0.08]

            shadow-sm
            dark:shadow-black/20

            hover:shadow-xl
            dark:hover:bg-white/[0.07]

            transition-all
            duration-300
          "
        >

          {/* Kart başlığı */}
          <div className="flex items-center gap-4 mb-6">

            <div
              className="
                w-12 h-12
                flex items-center justify-center
                rounded-2xl

                bg-gray-100
                dark:bg-white/[0.06]

                text-blue-600
                dark:text-blue-400

                transition-colors
              "
            >
              {section.icon}
            </div>

            <h3
              className="
                text-xl md:text-2xl
                font-black
                text-gray-900
                dark:text-white
              "
            >
              {section.title}
            </h3>

          </div>


          {/* Məzmun */}
          <ul className="grid gap-4">

            {section.content.map((item, i) => (

              <li
                key={i}
                className="flex items-start gap-3 group"
              >

                <div className="mt-1.5 min-w-[18px]">

                  <CheckCircle2
                    size={18}
                    className="
                      text-blue-500
                      opacity-60
                      group-hover:opacity-100
                      transition-opacity
                    "
                  />

                </div>

                <span
                  className="
                    text-base md:text-lg
                    leading-relaxed

                    text-gray-700
                    dark:text-gray-200

                    opacity-90
                  "
                >
                  {item}
                </span>

              </li>

            ))}

          </ul>

        </div>

      ))}

    </div>


    {/* =========================================================
        VACİB XƏBƏRDARLIQ
    ========================================================== */}
    <div
      className="
        mt-12
        p-6 md:p-8
        rounded-[2.5rem]

        bg-amber-50
        dark:bg-amber-500/10

        border
        border-amber-200
        dark:border-amber-500/20

        flex
        flex-col
        md:flex-row
        items-center
        gap-6

        transition-colors duration-300
      "
    >

      <div
        className="
          w-16 h-16
          shrink-0

          flex items-center justify-center

          bg-amber-500
          text-white

          rounded-2xl

          shadow-lg
          shadow-amber-500/20
        "
      >
        <AlertCircle size={32} />
      </div>


      <div className="text-center md:text-left">

        <h4
          className="
            text-xl
            font-black
            uppercase
            tracking-tight
            text-amber-600
            dark:text-amber-400
            mb-1
          "
        >
          Diqqət!
        </h4>

        <p
          className="
            font-medium
            leading-relaxed

            text-gray-700
            dark:text-gray-200

            opacity-90
          "
        >
          Qaydaları pozan elanlar moderator tərəfindən
          xəbərdarlıq edilmədən silinə bilər. Təkrar pozuntular
          zamanı istifadəçi bloklanacaqdır.
        </p>

      </div>

    </div>


    {/* =========================================================
        GERİ DÖNÜŞ
    ========================================================== */}
    <div className="mt-12 text-center">

      <button
        onClick={handleBack}
        className="
          group

          inline-flex
          items-center
          gap-3

          px-8 md:px-10
          py-4 md:py-5

          rounded-2xl

          bg-blue-600
          hover:bg-blue-700

          dark:bg-blue-600
          dark:hover:bg-blue-500

          text-white

          font-black
          text-lg md:text-xl

          shadow-xl
          shadow-blue-500/20

          transition-all
          duration-300

          active:scale-95
        "
      >

        Anladım, Elan Yerləşdir

        <ChevronRight
          size={22}
          className="
            group-hover:translate-x-1
            transition-transform
          "
        />

      </button>

    </div>

  </div>
</div>
  );
};

export default Rules;